//// CONTACT FORM ////
// https://codyhouse.co/gem/css-contact-form/

if ($('.floating-labels').length > 0) floatLabels();

function floatLabels() {
    var inputFields = $('.floating-labels .cd-label').next();
    inputFields.each(function() {
        var singleInput = $(this);
        //check if user is filling one of the form fields
        // checkVal(singleInput);
        singleInput.on('change keyup', function() {
            checkVal(singleInput);
        });

        singleInput.on("focusin", function() {
            $(this).prev('.cd-label').addClass('float2');
        });

        singleInput.on("focusout", function() {
            $(this).prev('.cd-label').removeClass('float2');
        });
    });
}

function checkVal(inputField) {
    (inputField.val() == '') ? inputField.prev('.cd-label').removeClass('float'): inputField.prev('.cd-label').addClass('float');
}


//FIX move label if input is filled
var inputFilled = document.querySelectorAll(".cd-formfield input[type='text'], .cd-formfield input[type='email'], .cd-formfield input[type='tel'], .cd-formfield input[type='number'], .cd-formfield input[type='password'], .cd-formfield select, .cd-formfield textarea");
for (var i = 0; i < inputFilled.length; i++) {
    if (inputFilled[i].value.length > 0) {
        inputFilled[i].previousElementSibling.classList.add('float');
    }
}


function adjustMargin() {
    var topbanner = document.getElementById('topbanner_login');
    var formInner = document.getElementById('holzpreis_form_inner');
    if (topbanner && formInner) {
      var height = topbanner.offsetHeight;
      formInner.style.paddingTop = height + "px";
      formInner.style.visibility = "visible"; // erst jetzt anzeigen
    }
  }
  
  document.addEventListener("DOMContentLoaded", adjustMargin);
  window.addEventListener("resize", adjustMargin);
  




/* ***************************
  PW vergessen beim Congress
  kopiert #fp_email in Username und Email 
  live bei Eingabe und sicherheithalber auch beim Abschicken
*************************** */

document.addEventListener('input', function (e) {
  if (!e.target || e.target.id !== 'fp_email') return;

  const form = e.target.closest('form');
  if (!form || form.id !== 'forgotlogin_popup_form') return;

  const email = (e.target.value || '').trim();
  const hiddenEmail = form.querySelector('input[name="email"]');
  const hiddenUser  = form.querySelector('input[name="username"]');

  if (hiddenEmail) hiddenEmail.value = email;
  if (hiddenUser)  hiddenUser.value  = email;
}, true);

document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form || form.id !== 'forgotlogin_popup_form') return;

  const emailInput = form.querySelector('#fp_email');
  if (!emailInput) return;

  const email = (emailInput.value || '').trim();
  const hiddenEmail = form.querySelector('input[name="email"]');
  const hiddenUser  = form.querySelector('input[name="username"]');

  if (hiddenEmail) hiddenEmail.value = email;
  if (hiddenUser)  hiddenUser.value  = email;
}, true);
